import {
  FETCH_EXPORT_REQUEST,
  FETCH_EXPORT_FAILURE,
} from './exportActionTypes';
import axios from 'axios';
import { store } from '../../../app/store';
import { alertAction } from '../Alert/alertActions';
import { Dispatch } from 'redux';
import { loaderAction } from '../loader/loaderActions';

const fetchExportRequest: any = () => ({
  type: FETCH_EXPORT_REQUEST,
});

const fetchExportFailure: any = (error: any) => ({
  type: FETCH_EXPORT_FAILURE,
  payload: error,
});

export const exportData: any = () => {
  const selectedData: any = store.getState().selectedValue;
  const user = store.getState().user.user;
  const gridHeader: any = {
    email: user.Email,
    isAdmin: user.IsAdmin,
    weekKey: selectedData.week.toString(),
    yearKey: selectedData.year.toString(),
    biRevline: selectedData.revenueType,
    affiliateNames: selectedData.affiliatesArray,
    salesMarkets: selectedData.salesMarketsArray,
  };

  return function (dispatch: Dispatch) {
    dispatch(fetchExportRequest());
    const comapre = selectedData.compare;

    if (comapre) {
      const bodyComapre: any = {
        firstTimePeriod: { ...gridHeader },
        secondTimePeriod: { ...gridHeader },
      };
      bodyComapre.secondTimePeriod.weekKey = (selectedData.week - 1).toString();
      if (selectedData.dateType === 'month') {
        delete gridHeader.weekKey;
        gridHeader.month = selectedData.month.toString();
        bodyComapre.firstTimePeriod.month = selectedData.month.toString();
        bodyComapre.secondTimePeriod.month = (selectedData.month - 1).toString();
      } else if (selectedData.dateType === 'quater') {
        delete gridHeader.weekKey;
        gridHeader.quarter = selectedData.quarter.toString();
        bodyComapre.firstTimePeriod.quarter = selectedData.quarter.toString();
        bodyComapre.secondTimePeriod.quarter = (selectedData.quarter - 1).toString();
      }
      dispatch(loaderAction(true) as any);
      axios
        .get(
          `${import.meta.env.VITE_BACKEND}api/AffiliateWeeklyRevenues/ExportAffiliatesPerformanceData`,
          {
            headers: {
              AffiliatePerformanceFilterExport: JSON.stringify(gridHeader),
            },
          },
        )
        .then((response: any) => {
          const message = response.data?.Message || response.data?.message;
          if (message === 'ExportInProgress') {
            dispatch(alertAction('Export is already in progress', true, 'info') as any);
          } else {
            dispatch(alertAction('Export Initiated', true, 'success') as any);
          }
          dispatch(loaderAction(false) as any);
        })
        .catch((error: any) => {
          const status = error.response?.status;
          const userMessage = status === 404
            ? 'Export service is currently unavailable. Please try again later.'
            : status === 500
            ? 'An unexpected server error occurred. Please try again later.'
            : 'Failed to export report. Please try again later.';
          dispatch(alertAction(userMessage, true, 'error') as any);
          dispatch(fetchExportFailure(error.message));
          dispatch(loaderAction(false) as any);
        });
    } else {
      if (selectedData.dateType === 'month') {
        delete gridHeader.weekKey;
        gridHeader.monthKey = selectedData.month.toString();
      } else if (selectedData.dateType === 'quater') {
        delete gridHeader.weekKey;
        gridHeader.quarterKey = selectedData.quarter.toString();
      }

      dispatch(loaderAction(true) as any);
      axios
        .get(
          `${import.meta.env.VITE_BACKEND}api/AffiliateWeeklyRevenues/ExportAffiliatesPerformanceData`,
          {
            headers: {
              AffiliatePerformanceFilterExport: JSON.stringify(gridHeader),
            },
          },
        )
        .then((response: any) => {
          const message = response.data?.Message || response.data?.message;
          if (message === 'ExportInProgress') {
            dispatch(alertAction('Export is already in progress', true, 'info') as any);
          } else {
            dispatch(alertAction('Export Initiated', true, 'success') as any);
          }
          dispatch(loaderAction(false) as any);
        })
        .catch((error: any) => {
          const status = error.response?.status;
          const userMessage = status === 404
            ? 'Export service is currently unavailable. Please try again later.'
            : status === 500
            ? 'An unexpected server error occurred. Please try again later.'
            : 'Failed to export report. Please try again later.';
          dispatch(alertAction(userMessage, true, 'error') as any);
          dispatch(fetchExportFailure(error.message));
          dispatch(loaderAction(false) as any);
        });
    }
  };
};
